import React from 'react';

import { Col } from 'react-bootstrap';

class Regulation extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="panel-page-internal">

				<div className="bg-green shadow">
					<div className="container-secondary">
						<Col md={12}>
							<h1 className="text-base text-bold">A PROMOÇÃO “JOGADA DE PRÊMIOS 2023” FOI PRORROGADA. FIQUEM ATENTOS AO NOVO PERÍODO DE PARTICIPAÇÃO</h1>
						</Col>
					</div>
				</div>

				<div className="container-secondary">
					<Col md={12}>
						<div className="clearfix">
							<h2 className="text-base text-bold text-center">COMUNICADO IMPORTANTE</h2>
							<p className="text-base text-bold">Caro Participante, <br />Comunicamos que o seu regulamento da promoção comercial foi alterado.</p>
							<p>A partir de setembro de 2022, <span className='text-bold'>o Regulamento da Promoção Comercial passará a excluir as seguintes determinações:</span></p>
							<p>1 - Desclassificação pela não localização dos participantes contemplados não localizados no prazo de 180 dias;</p>
							<p>2 - Desclassificação dos participantes contemplados notificados que não apresentarem os documentos necessários para realização do pagamento do prêmio de sorteio no prazo de 10 dias;</p>
							<p>3 - Desclassificação dos participantes que não mantiverem atualizados seus dados cadastrais;</p>
							<p>4 - Regra que prevê o pagamento do prêmio de sorteio dos participantes desclassificados para a Promotora;</p>
							<p>Ressaltamos que o prazo prescricional para recebimento do prêmio de sorteio é o previsto na legislação em vigor, que, atualmente, é de 5 anos.</p>
							<p>Sugerimos que mantenha seus dados cadastrais atualizados para receber as orientações para o pagamento em caso de contemplação.</p>
						</div>
					</Col>
				</div>

				<div className="container-secondary">
					<Col md={12}>
						<h2 className="text-base text-bold">REGULAMENTO DA PROMOÇÃO “JOGADA MUSICAL 2023”</h2>
					</Col>
				</div>

				<div className="container-secondary bg-white text-area">
					<Col md={12}>
						<div className="clearfix">
							<p>Dados da Empresa Promotora
								<br />
								<span className="text-bold">
									CLARO S.A.
								</span>
								<br />
								Av. Presidente Vargas, n° 1012 - Centro – Rio de Janeiro/RJ.
								<br />
								CNPJ: 40.432.544/0001-47
							</p>
						</div>
						<div className="clearfix">
							<h2>1. INFORMAÇÕES INICIAIS</h2>
							<p>1.1. CLARO S.A., aqui denominada PROMOTORA, é subscritora de títulos de capitalização, da modalidade Incentivo, administrados pela ICATU CAPITALIZAÇÃO S/A, doravante denominada Icatu, inscrita no CNPJ sob o nº. 74.267.170/0001-73, cujas notas técnicas e suas condições gerais foram aprovadas pela Superintendência de Seguros Privados - SUSEP, por meio do processo nº 15414.900617/2019-51 e cederá gratuitamente aos que preencherem as condições constantes neste Regulamento, o direito de participar dos sorteios relativos aos referidos Títulos.
							</p>
							<p>1.2. Os títulos de capitalização, cujos direitos de sorteio são cedidos aos participantes desta promoção, são de propriedade da PROMOTORA que conserva sobre eles a exceção do direito de participação nos sorteios e, todos os demais direitos e deveres inerentes a esta condição.
							</p>
							<p>1.3. A participação nesta Promoção é voluntária, e a aceitação do participante às condições estabelecidas neste Regulamento ocorre por meio de sua inscrição.</p>
						</div>
						<div className="clearfix">
							<h2>2. A PROMOÇÃO</h2>
							<p>2.1. A Promoção Jogada de Prêmios 2023 visa promover os serviços de interatividade da PROMOTORA, disponibilizados exclusivamente para clientes, pessoas físicas, maiores de 18 (dezoito) anos, residentes e domiciliados em todo Território Nacional usuários do serviço de telefonia móvel da Claro, inscritos em qualquer um dos planos ofertados, assinantes dos serviços Quiz Jogada Musical e Quiz Jogada de Prêmios, que estejam em dia com suas obrigações financeiras em relação à PROMOTORA, bem como atendam as demais condições de participação previstas neste Regulamento.</p>
						</div>
						<div className="clearfix">
							<h2>3. PERÍODO DA PROMOÇÃO E ABRANGÊNCIA GEOGRÁFICA</h2>
							<p>3.1. A Promoção “Jogada de Prêmios” estará em vigor no período de 24/07/2019 a 31/08/2024 e será realizada em todo território nacional.</p>
						</div>
						<div className="clearfix">
							<h2>4. MECÂNICA DE PARTICIPAÇÃO NA PROMOÇÃO</h2>
							<p>4.1. A promoção é voltada aos participantes que contratarem os serviços de entretenimento QUIZ JOGADA MUSICAL e QUIZ JOGADA DE PRÊMIOS, observada a correlação existente entre o período de aquisição e o respectivo sorteio conforme estabelecido no quadro do item 7.1.
							</p>
							<p><strong>4.2. Não poderão participar da Promoção os funcionários da agência Promotora, bem como qualquer pessoa ou funcionário de organização que esteja, direta ou indiretamente, envolvido em qualquer aspecto desta Promoção.</strong></p>
							<p><strong>4.2.1. Na hipótese de o contemplado pertencer ao grupo de impedidos, será desclassificado e, será aplicada a regra de aproximação prevista no item 10.4, prevista neste regulamento.</strong></p>
							<p>4.3. Serão realizados sorteios, por período de participação, contemplando um usuário ativo de um desses serviços de entretenimento, quais sejam QUIZ JOGADA MUSICAL e QUIZ JOGADA DE PRÊMIOS.</p>
						</div>
						<div className="clearfix">
							<h2>5. QUIZ JOGADA MUSICAL</h2>
							<p>5.1. O Quiz Jogada Musical é um serviço de interatividade da PROMOTORA, no formato trivia, que oferece testes relacionados ao universo da música.</p>
							<p>5.2. Os participantes interessados em assinar o serviço deverão fazê-lo por SMS, enviando SIM para o número 7979 ou através do site <a href="http://www.jogadamusical.com" targt="_blank">www.jogadamusical.com</a>.</p>
							<p>5.2.1. Após a assinatura do serviço Quiz Jogada Musical, o participante receberá uma mensagem de “boas vindas”.</p>
							<p>5.2.2. A partir da assinatura do serviço Quiz Jogada Musical todas as interatividades serão gratuitas e o Participante terá direito a participar da “Rodada do Dia” que consiste em 05 (cinco) perguntas do Quiz Jogada Musical. Ao todo, serão 07 “Rodadas”, totalizando 35 (trinta e cinco) perguntas por semana.</p>
							<p>5.2.3. As perguntas serão restritas ao universo da música e terão 03 (três) opções de resposta, sendo apenas 01 (uma) correta.</p>
							<p>5.2.3.1. Ao responder 3 (três) perguntas do Quiz Jogada Musical, no mesmo dia, independentemente do acerto, o participante receberá 1 (hum) número da sorte para concorrer ao sorteio dos prêmios, conforme o item 5.2.5, limitado à um cupom diário por usuário.</p>
							<p>5.2.4. A assinatura do serviço Quiz Jogada Musical é renovada automaticamente a cada 07 (sete) dias.</p>
							<p>5.2.5. Os usuários do “Quiz Jogada Musical” no ato da contratação ou reativação do serviço receberão a seguinte quantidade de Números da Sorte nos eventos a seguir: (i) 1 (hum) Número da Sorte para concorrer ao Prêmio mensal R$10.000,00 (dez mil reais)</p>
							<p>5.2.5.1. Os Números da Sorte sempre serão distribuídos considerando a data em que ocorrer os eventos acima e, o período de participação especificado no quadro do item 7.1 abaixo, na forma deste Regulamento.</p>
							<p>5.3. Ao participar desta Promoção os participantes autorizam a Promotora a enviar ofertas com condições especiais para participação em “Rodadas do Dia” extras, além de mensagens de cunho publicitário divulgando outros serviços da PROMOTORA. Estas condições especiais serão divulgadas, pelos canais apropriados, a todos os participantes.</p>
							<p>5.4. O serviço será disponibilizado na modalidade semanal, ao custo de R$ 4,99 (quatro reais e noventa e nove centavos) por semana.</p>
							<p>5.5. A qualquer momento o participante poderá solicitar ajuda enviando o comando AJUDA para o número 7979.</p>
							<p>5.6. O participante poderá desativar o serviço a qualquer momento, bastando enviar uma mensagem de texto com a palavra SAIR para o número 7979.</p>
							<p>5.7. Os participantes poderão conhecer a quantidade de os “Números da Sorte” pelo envio de um Torpedo SMS, GRATUITO, com o comando SALDO, para o número 7979.</p>
							<p>5.7.1. Os participantes poderão consultar seus “Números da Sorte” através do site <a href="http://www.jogadamusical.com" targt="_blank">www.jogadamusical.com</a>.</p>
							<p>5.8 A. PROMOTORA poderá distribuir através de ações de mídia, broadcast SMS ou outros meios, degustações gratuitas do serviço em formato de "Rodadas do Dia" de até 5 (cinco) perguntas de forma totalmente gratuita.</p>
							<p>5.8.1. Após cada sequência de 3 (três) perguntas respondidas, no mesmo dia, independentemente do número de acertos, o usuário participante da degustação receberá a seguinte quantidade de Números da Sorte:  01 (um) Número da Sorte para concorrer ao Prêmio mensal de R$ 10.000,00 (dez mil reais), limitado à um cupom mensal por usuário.</p>
							<p>5.8.2. O envio das perguntas relacionadas a degustação gratuita em formato de "Rodadas do dia" poderá: (i) ser suspensa a qualquer momento a critério da PROMOTORA e (ii) cancelada definitivamente a pedido do participante, bastando  o envio de algum dos comandos de cancelamento aqui definidas, sendo: SAIR, CHEGA, CANCELAR, CANCELA, CANC, CANCEL, OFF, STOP, FIM, END, SAI, NÃO, NAO QUERO, NÃO MAIS, NAO MAIS, NÃO QUERO MAIS, NAO QUERO MAIS, DESC, DESCADASTRA, DESCADASTRAR, PARA, PARAR, PARE, PAREM, CHEGA, CHEGUEM.</p>
						</div>
						<div className="clearfix">
							<h2>6. QUIZ JOGADA DE PRÊMIOS</h2>
							<p>6.1. O Quiz Jogada de Prêmios é um serviço de interatividade da PROMOTORA, no formato trivia, que oferece testes relacionados a conhecimentos gerais.</p>
							<p>6.2. Os participantes interessados em assinar o serviço deverão fazê-lo por SMS, enviando SIM para o número 8888 ou através do site <a href="http://www.jogadadepremios.com" target="_blank">www.jogadadepremios.com</a>.</p>
							<p>6.2.1. Após a assinatura do serviço Quiz Jogada de Prêmios, o participante receberá uma mensagem de “boas vindas”.</p>
							<p>6.2.2. A partir da assinatura do serviço Quiz Jogada de Prêmios todas as interatividades serão gratuitas e o Participante terá direito a participar da “Rodada do Dia” que consiste em 05 (cinco) perguntas do Quiz Jogada de Prêmios. Ao todo, serão 07 “Rodadas”, totalizando 35 (trinta e cinco) perguntas por semana.</p>
							<p>6.2.3. As perguntas serão sobre conhecimentos gerais e terão 03 (três) opções de resposta, sendo apenas 01 (uma) correta.</p>
							<p>6.2.3.1. Ao responder 3 (três) perguntas do Quiz Jogada de Prêmios no mesmo dia, independentemente do acerto, o participante receberá 1 (hum) número da sorte para concorrer ao sorteio dos prêmios, conforme o item 6.2.5, limitado à um cupom diário por usuário.</p>
							<p>6.2.4. A assinatura do serviço Quiz Jogada de Prêmios é renovada automaticamente a cada 07 (sete) dias.</p>
							<p>6.2.5. Os usuários do “Quiz Jogada de Prêmios”, no ato da contratação ou reativação do serviço, receberão 1 (hum) Número da Sorte para concorrer ao Prêmio mensal R$10.000,00 (dez mil reais).</p>
							<p>6.2.5.1. Os Números da Sorte sempre serão distribuídos considerando a data em que ocorrer os eventos acima e o período de participação especificado no quadro do item 7.1 abaixo, na forma deste Regulamento.</p>
							<p>6.3. Ao participar desta Promoção os participantes autorizam a Promotora a enviar ofertas com condições especiais para participação em “Rodadas do Dia” extras, além de mensagens de cunho publicitário divulgando outros serviços da PROMOTORA. Estas condições especiais serão divulgadas, pelos canais apropriados, a todos os participantes.</p>
							<p>6.4. O serviço será disponibilizado na modalidade semanal, ao custo de R$ 4,99 (quatro reais e noventa e nove centavos) por semana.</p>
							<p>6.5. A qualquer momento o participante poderá solicitar ajuda enviando o comando AJUDA para o número 8888.</p>
							<p>6.6. O participante poderá desativar o serviço a qualquer momento, bastando enviar uma mensagem de texto com a palavra SAIR para o número 8888.</p>
							<p>6.7. Os participantes poderão conhecer os a quantidade de “Números da Sorte” pelo envio de um Torpedo SMS, GRATUITO, com o comando SALDO, para o número 8888.</p>
							<p>6.7.1. Os participantes poderão consultar seus “Números da Sorte” através do site <a href="http://www.jogadadepremios.com" targt="_blank">www.jogadadepremios.com</a>.</p>
							<p>6.8. A PROMOTORA poderá distribuir através de ações de mídia, broadcast SMS ou outros meios, degustações gratuitas do serviço em formato de "Rodadas do Dia" de até 5 (cinco) perguntas de forma totalmente gratuita.</p>
							<p>6.8.1. A cada sequência de 3 (três) perguntas respondidas no mesmo dia, independentemente do número de acertos, o usuário participante da degustação receberá 01 (um) Número da Sorte para concorrer ao Prêmio mensal de R$ 10.000,00 (dez mil reais), limitado à um cupom diário por usuário.</p>
							<p>6.8.2. O envio das perguntas relacionadas a degustação gratuita em formato de "Rodadas do dia" poderá: (i) ser suspensa a qualquer momento a critério da PROMOTORA e (ii) cancelada definitivamente a pedido do participante, bastando  o envio de algum dos comandos de cancelamento aqui definidos, sendo: SAIR, CHEGA, CANCELAR, CANCELA, CANC, CANCEL, OFF, STOP, FIM, END, SAI, NÃO, NAO QUERO, NÃO MAIS, NAO MAIS, NÃO QUERO MAIS, NAO QUERO MAIS, DESC, DESCADASTRA, DESCADASTRAR, PARA, PARAR, PARE, PAREM, CHEGA, CHEGUEM.</p>
						</div>
						<div className="clearfix">
							<h2>7. PERÍODOS DE PARTICIPAÇÃO</h2>
							<p>7.1. Serão distribuídos os seguintes prêmios nesta promoção, conforme o cronograma
								abaixo:</p>
							<div className="table-scroll">
								<table className="table table-bordered table-schedule">
									<thead>
										<tr>
											<th>Início de Participação</th>
											<th>Fim de Participação</th>
											<th>Data de Sorteio</th>
											<th>Valor do sorteio líquido</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>24/07/2019</td>
											<td>13/09/2019</td>
											<td>14/09/2019</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>14/09/2019</td>
											<td>11/10/2019</td>
											<td>12/10/2019</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>12/10/2019</td>
											<td>08/11/2019</td>
											<td>09/11/2019</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>09/11/2019</td>
											<td>13/12/2019</td>
											<td>14/12/2019</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>14/12/2019</td>
											<td>10/01/2020</td>
											<td>11/01/2020</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>11/01/2019</td>
											<td>14/02/2020</td>
											<td>15/02/2020</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>15/02/2020</td>
											<td>13/03/2020</td>
											<td>14/03/2020</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>14/03/2020</td>
											<td>10/04/2020</td>
											<td>11/04/2020</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>11/04/2020</td>
											<td>08/05/2020</td>
											<td>09/05/2020</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>09/05/2020</td>
											<td>12/06/2020</td>
											<td>13/06/2020</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>13/06/2020</td>
											<td>10/07/2020</td>
											<td>11/07/2020</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>11/07/2020</td>
											<td>13/08/2020</td>
											<td>15/08/2020</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>15/08/2020</td>
											<td>18/09/2020</td>
											<td>19/09/2020</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>19/09/2020</td>
											<td>16/10/2020</td>
											<td>17/10/2020</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>17/10/2020</td>
											<td>13/11/2020</td>
											<td>14/11/2020</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>14/11/2020</td>
											<td>18/12/2019</td>
											<td>19/12/2020</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>19/12/2020</td>
											<td>15/01/2021</td>
											<td>16/01/2021</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>16/01/2021</td>
											<td>19/02/2021</td>
											<td>20/02/2021</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>20/02/2021</td>
											<td>19/03/2021</td>
											<td>20/03/2021</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>20/03/2021</td>
											<td>16/04/2021</td>
											<td>17/04/2021</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>17/04/2021</td>
											<td>14/05/2021</td>
											<td>15/05/2021</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>15/05/2021</td>
											<td>18/06/2021</td>
											<td>19/06/2021</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>19/06/2021</td>
											<td>16/07/2021</td>
											<td>17/07/2021</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>17/07/2021</td>
											<td>13/08/2021</td>
											<td>14/08/2021</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>14/08/2021</td>
											<td>10/09/2021</td>
											<td>11/09/2021</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>11/09/2021</td>
											<td>08/10/2021</td>
											<td>09/10/2021</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>09/10/2021</td>
											<td>05/11/2021</td>
											<td>06/11/2021</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>06/11/2021</td>
											<td>03/12/2021</td>
											<td>04/12/2021</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>04/12/2021</td>
											<td>07/01/2022</td>
											<td>08/01/2022</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>08/01/2022</td>
											<td>04/02/2022</td>
											<td>05/02/2022</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>05/02/2022</td>
											<td>04/03/2022</td>
											<td>05/03/2022</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>05/03/2022</td>
											<td>01/04/2022</td>
											<td>02/04/2022</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>02/04/2022</td>
											<td>06/05/2022</td>
											<td>07/05/2022</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>07/05/2022</td>
											<td>03/06/2022</td>
											<td>04/06/2022</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>04/06/2022</td>
											<td>01/07/2022</td>
											<td>02/07/2022</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>02/07/2022</td>
											<td>05/08/2022</td>
											<td>06/08/2022</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>06/08/2022</td>
											<td>02/09/2022</td>
											<td>03/09/2022</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>03/09/2022</td>
											<td>30/09/2022</td>
											<td>01/10/2022</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>01/10/2022</td>
											<td>04/11/2022</td>
											<td>05/11/2022</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>05/11/2022</td>
											<td>02/12/2022</td>
											<td>03/12/2022</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>03/12/2022</td>
											<td>30/12/2022</td>
											<td>31/12/2022</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>31/12/2022</td>
											<td>27/01/2023</td>
											<td>28/01/2023</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>28/01/2023</td>
											<td>03/03/2023</td>
											<td>04/03/2023</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>04/03/2023</td>
											<td>31/03/2023</td>
											<td>01/04/2023</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>01/04/2023</td>
											<td>28/04/2023</td>
											<td>29/04/2023</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>29/04/2023</td>
											<td>26/05/2023</td>
											<td>27/05/2023</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>27/05/2023</td>
											<td>30/06/2023</td>
											<td>01/07/2023</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>01/07/2023</td>
											<td>28/07/2023</td>
											<td>29/07/2023</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>01/07/2023</td>
											<td>28/07/2023</td>
											<td>29/07/2023</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>29/07/2023</td>
											<td>25/08/2023</td>
											<td>26/08/2023</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>26/08/2023</td>
											<td>29/09/2023</td>
											<td>30/09/2023</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>30/09/2023</td>
											<td>27/10/2023</td>
											<td>28/10/2023</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>28/10/2023</td>
											<td>24/11/2023</td>
											<td>25/11/2023</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>25/11/2023</td>
											<td>29/11/2023</td>
											<td>30/12/2023</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>30/12/2023</td>
											<td>26/01/2024</td>
											<td>27/01/2024</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>27/01/2024</td>
											<td>23/02/2024</td>
											<td>24/02/2024</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>24/02/2024</td>
											<td>29/03/2024</td>
											<td>30/03/2024</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>30/03/2024</td>
											<td>26/04/2024</td>
											<td>27/04/2024</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>27/04/2024</td>
											<td>24/05/2024</td>
											<td>25/05/2024</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>25/05/2024</td>
											<td>28/06/2024</td>
											<td>29/06/2024</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>29/06/2024</td>
											<td>26/07/2024</td>
											<td>27/07/2024</td>
											<td>R$ 10.000,00</td>
										</tr>
										<tr>
											<td>27/07/2024</td>
											<td>30/08/2024</td>
											<td>31/08/2024</td>
											<td>R$ 10.000,00</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div className="clearfix">
							<h2>8. DAS PREMIAÇÕES</h2>
							<p>8.1. Os Participantes concorrerão durante o período da Promoção ao total de 48 (quarenta e oito) prêmios, no valor de R$ 10.000,00 (dez mil reais) cada, líquido de Imposto de Renda.</p>
							<p>8.2. Os valores da premiação acima citados são líquidos de tributos, os quais serão recolhidos pela Icatu na forma da legislação vigente, conforme respectivas Condições Gerais.</p>
							<p>8.3. Os prêmios são lastreados em títulos de capitalização emitidos pela Icatu, sorteados com base na extração realizada pela Loteria Federal do Brasil.</p>
							<p>8.4. O usuário contemplado poderá escolher entre o valor de R$ 10.000,00 (dez mil reais) ou optar por uma das seguintes experiências: (i) experiência com artista; (ii) experiência turística; (iii) experiência esportiva; (iv) experiência gastronômica; (v) experiência cultural; (vi) produtos  comerciais  diversos,  tais  como  aparelhos  celulares, computadores, games, eletrônicos ou outros.</p>
							<p>8.4.1. As sugestões listadas no item 8.4 acima, estão limitadas ao valor da premiação mensal, qual seja R$ 10.000,00 (dez mil reais)</p>
						</div>
						<div className="clearfix">
							<h2>9. APURAÇÃO</h2>
							<p>9.1. Os sorteios serão apurados pelas extrações da Loteria Federal do Brasil. Não ocorrendo extração da Loteria Federal em uma das datas previstas, o sorteio correspondente será adiado para a primeira extração que vier a ser por ela realizada até o dia que anteceder à respectiva extração subsequente. Os resultados da Loteria Federal do Brasil poderão ser     acompanhados     por     meio     do     site <a href="http://loterias.caixa.gov.br/wps/portal/loterias/landing/federal"
								target="_blank">http://loterias.caixa.gov.br/wps/portal/loterias/landing/federal</a>, bem como em todas as Casas Lotéricas do Brasil.</p>
							<p>9.2. Para efeito de apuração serão considerados os 05 (cinco) primeiros prêmios da extração da Loteria Federal, observada a ordem de premiação. A combinação de sorteio será obtida da seguinte maneira:</p>
							<p>a) Será apurado o algarismo da centena simples do primeiro prêmio da Loteria Federal;</p>
							<p>b) Será apurado o algarismo da dezena simples do primeiro prêmio da Loteria Federal;</p>
							<p>c) Será apurado o número, composto de cinco algarismos, obtido através da leitura, de cima para baixo, da coluna formada pelo algarismo da unidade simples dos cinco primeiros prêmios da Loteria Federal;</p>
							<p>d) Caso o algarismo apurado na alínea (a) acima, seja par, será considerado o algarismo 0;</p>
							<p>e) Caso o algarismo apurado na alínea (a) acima, seja ímpar, será considerado o algarismo 1;</p>
							<p>f) A combinação contemplada será igual a junção do algarismo 0 ou 1, apurado nas alíneas (d) ou (e), o número apurado na alínea (b) e o número apurado na alínea (c), nesta ordem.</p>
							<p>g) Para exemplificar a combinação sorteada considere os seguintes prêmios da Loteria Federal:</p>
							<div className="table-scroll">
								<table className="table table-bordered table-schedule">
									<tbody>
										<tr>
											<td>1º prêmio da Loteria Federal</td>
											<td>6</td>
											<td>8</td>
											<td>9</td>
											<td>8</td>
											<td>1</td>
										</tr>
										<tr>
											<td>2º prêmio da Loteria Federal</td>
											<td>8</td>
											<td>7</td>
											<td>9</td>
											<td>6</td>
											<td>2</td>
										</tr>
										<tr>
											<td>3º prêmio da Loteria Federal</td>
											<td>3</td>
											<td>4</td>
											<td>7</td>
											<td>6</td>
											<td>4</td>
										</tr>
										<tr>
											<td>4º prêmio da Loteria Federal</td>
											<td>2</td>
											<td>1</td>
											<td>4</td>
											<td>3</td>
											<td>9</td>
										</tr>
										<tr>
											<td>5º prêmio da Loteria Federal</td>
											<td>6</td>
											<td>3</td>
											<td>2</td>
											<td>1</td>
											<td>5</td>
										</tr>
									</tbody>
								</table>
							</div>
							<p>Algarismo da centena simples do primeiro prêmio: 5 => implica no algarismo 1</p>
							<p>Algarismo da dezena simples do primeiro prêmio: 8</p>
							<p>Número apurado através da unidade simples: 12 495 => combinação apurada: 1.812.495</p>
							<p>9.3. Se por qualquer motivo a Loteria Federal não venha a realizar a extração na data prevista, será considerada, para os fins do disposto neste artigo, a primeira extração que vier a ser por ela realizada até o dia que anteceder à respectiva extração subsequente.</p>
							<p>9.4. Caso o Número da Sorte apurado na forma acima não esteja vinculado a um Participante desta promoção ou esteja vinculado a um Participante que não atenda às condições estabelecidas neste regulamento, aplicar-se-á a seguinte regra de aproximação: será contemplado o Participante que possuir o Número da Sorte imediatamente superior ou, na falta deste, ao imediatamente inferior e assim, sucessivamente, até que seja identificado o Participante Contemplado.</p>
						</div>
						<div className="clearfix">
							<h2>10. DO PAGAMENTO DOS PRÊMIOS</h2>
							<p>10.1. A ICATU CAPITALIZAÇÃO S/A efetuará o pagamento do Prêmio ao Participante contemplado, no prazo máximo de 15 (quinze) dias corridos contados da data do recebimento de toda a documentação necessária ao pagamento, a saber, cópia da identidade e CPF/MF, válidos, além de comprovante de residência atualizado (expedido no máximo há cento e oitenta dias da apresentação), bem como informe profissão e renda e assine termo de recebimento e quitação do valor do Prêmio.</p>
							<p>10.2. O pagamento do prêmio será efetivado por qualquer meio legalmente admitido.</p>
							<p>10.3. Fica estabelecido que o participante contemplado que não for localizado no prazo de 180 dias, contados a partir da data de realização do sorteio, será desclassificado, sendo certo que serão realizadas durante o prazo acima, tentativas de localização, preferencialmente por contato telefônico. Em caso de insucesso, será realizada nova(s) tentativa(s) de contato observando a seguinte ordem: 01 (um) e-mail, com confirmação de envio e, caso o cliente não tenha fornecido e-mail e/ou não tenha sido localizado  na  tratativa  anterior,  será  enviada  (ii)  01  (uma) correspondência com aviso de recebimento com base nos dados cadastrados junto a operadora de telefonia móvel Claro. Em caso de desclassificação, o prêmio será revertido para PROMOTORA.</p>
							<p>10.3.1. O participante contemplado que for comunicado da contemplação e não contatar a PROMOTORA e/ou não apresentar os documentos necessários para o pagamento do prêmio, no prazo de 30 dias corridos, contados a partir da data da comunicação do sorteio, será desclassificado. Em caso de desclassificação, o prêmio será revertido para PROMOTORA.</p>
							<p>10.4. A PROMOTORA informa que irá compartilhar os documentos do(s) participante(s) contemplado(s), mencionados no item 10.1, com a sociedade de capitalização. O referido compartilhamento tem como objetivo viabilizar o pagamento da premiação e cumprir com exigências regulatórias.</p>
							<p>10.5. Caso o contemplado opte pelo recebimento do prêmio por meio de depósito bancário, deverá informar os dados necessários à realização do depósito e o respectivo comprovante servirá como prova da entrega e quitação do prêmio.</p>
							<p>10.5.1. O depósito bancário, somente, poderá ser realizado em conta de titularidade do contemplado.</p>
							<p>10.5.2. Na eventualidade do contemplado falecer, o prêmio será entregue ao respectivo espólio, na pessoa do seu inventariante, mediante apresentação de alvará judicial. Não havendo processo de inventário, será entregue aos sucessores legais do contemplado, desde que devidamente comprovada tal condição, nos termos da legislação aplicável, mediante apresentação de alvará judicial.</p>
							<p>10.5.3. Na impossibilidade do contemplado receber diretamente o seu prêmio será admitida sua representação na forma abaixo:</p>
							<p>I. Mediante a apresentação de procuração por instrumento público, lavrada no cartório competente, com indicação expressa dos poderes para tal e do representante nomeado;</p>
							<p>II. Mediante a apresentação de procuração por instrumento particular, obrigatoriamente com reconhecimento de firma do outorgante, e a indicação expressa dos poderes para tal e do representante nomeado.</p>
							<p>10.6. Caso seja identificado comportamento fraudador, por eventual contemplado, o mesmo será desclassificado.</p>
						</div>
						<div className="clearfix">
							<h2>11. CONSIDERAÇÕES FINAIS</h2>
							<p>11.1. Não terão validade as participações que não preencherem às condições previstas neste regulamento, sendo o participante, em caso de contemplação, desclassificado.</p>
							<p>11.2. O contemplado autoriza, em caráter irrevogável e irretratável, a utilização do seu nome, imagem e voz para divulgação desta promoção e da sua premiação, na mídia impressa, televisiva radiofônica e/ou eletrônica, pelo prazo de 2 (dois) anos contado a partir do sorteio, sem qualquer ônus para as Sociedades envolvidas nesta promoção.</p>
							<p>11.3. A autorização citada no item 11.2, é exclusiva para este fim, não significa, nem implica ou resulta em obrigatoriedade de divulgação, tampouco em pagamento ao contemplado.</p>
							<p>11.4. Os resultados dos sorteios, bem como o nome dos contemplados serão divulgados nos sites <a href="http://www.jogadamusical.com" targt="_blank">www.jogadamusical.com</a> e/ou <a href="http://www.jogadadepremios.com" targt="_blank">www.jogadadepremios.com</a></p>
							<p>11.5. Ao participar desta promoção, o interessado automaticamente aceita os termos
								deste regulamento.</p>
							<p>11.6. A PROMOTORA obriga-se a identificar todos os participantes cessionários dos direitos dos eventuais Títulos integralmente cedidos, bem como identificar todos os ganhadores dos prêmios de sorteio.</p>
							<p>11.7. A aprovação do Título pela SUSEP não implica, por parte da Autarquia, em incentivo ou recomendação a sua aquisição, representando, exclusivamente, sua adequação às normas em vigor.</p>
							<p>11.8. O Regulamento está disponível nos sites <a href="http://www.jogadamusical.com" targt="_blank">www.jogadamusical.com</a> e/ou <a href="http://www.jogadadepremios.com" targt="_blank">www.jogadadepremios.com</a>.</p>
						</div>
					</Col>
				</div>
			</div>
		);
	}
}

export default Regulation;


// WEBPACK FOOTER //
// ./src/components/pages/regulation.component.jsx